<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.gender')"
      filterable
      clearable
      :multiple="multiple"
      class="d-block"
      :size="size"
      :class="mode ? 'input__day' : 'input__night'"
    >
      <el-option
        v-for="(gender, index) in genders"
        :key="'genders-' + index"
        :label="gender.name"
        :value="gender.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    id: {
      handler: function () {
        this.selected = this.id;
      },
      immediate: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    if (this.genders && this.genders.length === 0) this.updateInventory();
  },
  computed: {
    ...mapGetters({
      genders: "gender/inventory",
      mode:'MODE'
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "gender/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
